<template>
	<div v-if="isLoading" class="fixed top-1/2 left-1/2">
		<Loading />
	</div>
	<div v-else>
		<div class="tabs flex mb-10 gap-4">
			<div v-for="tab in tabs" :key="tab.value">
				<div
					:class="{ 'tab-selected': tabSelected == tab.value }"
					class="tab flex items-center justify-center cursor-pointer"
					@click="tabSelected = tab.value"
				>
					{{ tab.name }}
				</div>
			</div>
		</div>
		<div
			v-if="skill_count || isAddGoalTour"
			class="p-6 bg-white shadow-sm rounded-2xl mb-10"
		>
			<div>
				<div class="flex items-center justify-between mb-6">
					<div class="font-semibold text-neutral-600">Thống kê</div>
					<div class="flex justify-end items-center">
						<Menu
							v-if="!is_old_data"
							as="div"
							class="ml-3 relative"
						>
							<div>
								<MenuButton
									data-tour-id="bank-more-btn"
									class="
										rounded-full
										flex
										text-sm
										focus:outline-none
										focus:ring-2
										focus:ring-offset-2
										focus:ring-indigo-500
									"
									@click="onBankMoreClick"
								>
									<span class="sr-only">Open user menu</span>
									<svg
										fill="none"
										height="20"
										viewBox="0 0 20 20"
										width="20"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											clip-rule="evenodd"
											d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
											fill="#94A3B8"
											fill-rule="evenodd"
										/>
									</svg>
								</MenuButton>
							</div>
							<transition
								enter-active-class="transition ease-out duration-200"
								enter-from-class="transform opacity-0 scale-95"
								enter-to-class="transform opacity-100 scale-100"
								leave-active-class="transition ease-in duration-75"
								leave-from-class="transform opacity-100 scale-100"
								leave-to-class="transform opacity-0 scale-95"
							>
								<MenuItems
									class="
										origin-top-right
										absolute
										right-0
										mt-2
										w-60
										rounded-md
										py-1
										bg-white
										focus:outline-none
										z-10
										shadow-sm
										border border-yellow-100
									"
								>
									<MenuItem
										v-if="tabSelected == 0"
										v-slot="{ active }"
										@click="
											$router.push(
												`/create-group/0?student_id=${id}&type=library`
											)
										"
									>
										<div
											:class="active ? '' : ''"
											class="
												p-2
												px-4
												bg-white
												z-10
												text-gray-600
												hover:bg-neutral-50
												flex
												items-center
												gap-4
												cursor-pointer
											"
										>
											<svg
												fill="none"
												height="16"
												viewBox="0 0 16 16"
												width="16"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
													fill="#94A3B8"
													fill-rule="evenodd"
												/>
											</svg>
											<span class="mt-0.5"
												>Tạo nhóm mới</span
											>
										</div>
									</MenuItem>
									<MenuItem
										v-if="tabSelected == 1"
										v-slot="{ active }"
										@click="
											$router.push(
												`/create-goal?student_id=${id}`
											)
										"
									>
										<div
											:class="active ? '' : ''"
											class="
												p-2
												px-4
												bg-white
												z-10
												text-gray-600
												hover:bg-neutral-50
												flex
												items-center
												gap-4
												cursor-pointer
											"
										>
											<svg
												fill="none"
												height="16"
												viewBox="0 0 16 16"
												width="16"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
													fill="#94A3B8"
													fill-rule="evenodd"
												/>
											</svg>
											<span class="mt-0.5"
												>Tạo mục tiêu chung</span
											>
										</div>
									</MenuItem>
									<MenuItem
										v-if="tabSelected == 0"
										v-slot="{ active }"
										@click="redirectCreatePage"
									>
										<div
											data-tour-id="bank-edit-item"
											:class="active ? '' : ''"
											class="
												p-2
												px-4
												bg-white
												z-10
												text-gray-600
												hover:bg-neutral-50
												flex
												items-center
												gap-4
												cursor-pointer
											"
										>
											<svg
												fill="none"
												height="16"
												viewBox="0 0 16 16"
												width="16"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M12.4705 6.65175L13.7105 5.41172C13.8463 5.27586 13.9143 5.20793 13.9669 5.14597C14.6011 4.39929 14.6011 3.30311 13.9669 2.55644C13.9143 2.49448 13.8463 2.42655 13.7105 2.29069C13.5746 2.15482 13.5067 2.08689 13.4447 2.03426C12.6981 1.40004 11.6019 1.40004 10.8552 2.03426C10.7933 2.08688 10.7253 2.15479 10.5895 2.29059L10.5895 2.29067L10.5894 2.29069L9.33123 3.5489C10.0749 4.84309 11.1586 5.91837 12.4705 6.65175ZM7.87657 5.00356L2.86297 10.0172C2.43791 10.4422 2.22538 10.6547 2.08565 10.9158C1.94591 11.1769 1.88697 11.4717 1.76908 12.0611L1.37342 14.0394C1.3069 14.372 1.27364 14.5383 1.36825 14.6329C1.46286 14.7275 1.62916 14.6943 1.96177 14.6277L3.94005 14.2321L3.94007 14.2321L3.94009 14.2321C4.52951 14.1142 4.82423 14.0553 5.08532 13.9155C5.34641 13.7758 5.55894 13.5633 5.98398 13.1382L5.984 13.1382L5.98401 13.1382L11.012 8.11019C9.75135 7.31198 8.68226 6.25011 7.87657 5.00356Z"
													fill="#94A3B8"
													fill-rule="evenodd"
												/>
											</svg>

											<span class="mt-0.5"
												>Chỉnh sửa</span
											>
										</div>
									</MenuItem>
									<MenuItem
										v-if="tabSelected == 0"
										v-slot="{ active }"
										@click="
											$router.push(
												`/recommend-goal/${id}`
											)
										"
									>
										<div
											:class="active ? '' : ''"
											class="
												p-2
												px-4
												bg-white
												z-10
												text-gray-600
												hover:bg-neutral-50
												flex
												items-center
												gap-4
												cursor-pointer
											"
										>
											<svg
												width="16"
												height="16"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M9.44934 13.3447H6.58986C6.32679 13.3447 6.11328 13.5582 6.11328 13.8213V14.5702C6.11328 14.824 6.31372 15.0277 6.56426 15.0419L6.9123 15.7048C6.99727 15.8676 7.21622 16 7.40032 16H8.63888C8.82298 16 9.04193 15.8676 9.1269 15.7048L9.47494 15.0419C9.72494 15.0283 9.92592 14.8246 9.92592 14.5702V13.8213C9.92592 13.5582 9.71187 13.3447 9.44934 13.3447Z"
													fill="#94A3B8"
												/>
												<path
													d="M8.01983 1.90632C8.24532 1.90632 8.42832 1.72331 8.42832 1.49782V0.408497C8.42832 0.183007 8.24532 0 8.01983 0C7.79433 0 7.61133 0.183007 7.61133 0.408497V1.49782C7.61133 1.72331 7.79433 1.90632 8.01983 1.90632Z"
													fill="#94A3B8"
												/>
												<path
													d="M14.9636 6.94446H13.8743C13.6488 6.94446 13.4658 7.12746 13.4658 7.35296C13.4658 7.57845 13.6488 7.76145 13.8743 7.76145H14.9636C15.1891 7.76145 15.3721 7.57845 15.3721 7.35296C15.3721 7.12746 15.1891 6.94446 14.9636 6.94446Z"
													fill="#94A3B8"
												/>
												<path
													d="M2.16481 6.94446H1.07549C0.849999 6.94446 0.666992 7.12746 0.666992 7.35296C0.666992 7.57845 0.849999 7.76145 1.07549 7.76145H2.16481C2.39031 7.76145 2.57331 7.57845 2.57331 7.35296C2.57331 7.12746 2.39031 6.94446 2.16481 6.94446Z"
													fill="#94A3B8"
												/>
												<path
													d="M12.6408 2.15363L11.8707 2.92378C11.7111 3.08336 11.7111 3.34208 11.8707 3.50167C12.0303 3.66125 12.2895 3.66125 12.4491 3.50167L13.2193 2.73151C13.3788 2.57193 13.3788 2.31321 13.2193 2.15363C13.0597 1.99404 12.8004 1.99404 12.6408 2.15363Z"
													fill="#94A3B8"
												/>
												<path
													d="M3.59004 11.2037L2.81988 11.9738C2.6603 12.1334 2.6603 12.3927 2.81988 12.5523C2.97947 12.7118 3.23819 12.7118 3.39777 12.5523L4.16793 11.7821C4.32751 11.6225 4.32751 11.3638 4.16793 11.2037C4.00834 11.0441 3.74962 11.0441 3.59004 11.2037Z"
													fill="#94A3B8"
												/>
												<path
													d="M12.4491 11.2037C12.2895 11.0441 12.0303 11.0441 11.8707 11.2037C11.7111 11.3638 11.7111 11.6225 11.8707 11.7821L12.6408 12.5523C12.8004 12.7118 13.0597 12.7118 13.2193 12.5523C13.3788 12.3927 13.3788 12.1334 13.2193 11.9738L12.4491 11.2037Z"
													fill="#94A3B8"
												/>
												<path
													d="M3.59004 3.50167C3.74962 3.66125 4.00834 3.66125 4.16793 3.50167C4.32751 3.34208 4.32751 3.08336 4.16793 2.92378L3.39777 2.15363C3.23819 1.99404 2.97947 1.99404 2.81988 2.15363C2.6603 2.31321 2.6603 2.57193 2.81988 2.73151L3.59004 3.50167Z"
													fill="#94A3B8"
												/>
												<path
													d="M8.01919 2.99561C5.58237 2.99561 3.60742 4.97055 3.60742 7.40737C3.60742 8.61162 4.09108 9.7004 4.87376 10.4951C5.33237 10.9608 5.85579 11.6432 6.04206 12.3164C6.1145 12.5773 6.33237 12.8001 6.60307 12.8001H9.43531C9.70656 12.8001 9.92333 12.5773 9.99632 12.3164C10.1831 11.6443 10.7066 10.9618 11.1652 10.4951C11.9484 9.7004 12.431 8.61162 12.431 7.40737C12.431 4.97055 10.4566 2.99561 8.01919 2.99561ZM7.5486 4.86543C6.52137 5.05443 5.69185 5.86761 5.48379 6.8894C5.44457 7.08276 5.27409 7.21674 5.084 7.21674C5.05677 7.21674 5.02954 7.21402 5.0023 7.20857C4.78117 7.16336 4.63847 6.94822 4.68368 6.72709C4.95655 5.38177 6.0486 4.31042 7.401 4.06206C7.62431 4.02229 7.83564 4.16826 7.87703 4.38994C7.91734 4.61162 7.77028 4.82458 7.5486 4.86543Z"
													fill="#94A3B8"
												/>
											</svg>
											<span class="mt-0.5"
												>Gợi ý mục tiêu</span
											>
										</div>
									</MenuItem>
								</MenuItems>
							</transition>
						</Menu>
					</div>
				</div>
			</div>
			<div
				:class="
					total_group_count < 1 && tabSelected == 0
						? ' md:grid-cols-2'
						: tabSelected == 1
						? ' md:grid-cols-5'
						: 'md:grid-cols-3'
				"
				class="grid grid-cols-1"
			>
				<div
					v-if="total_group_count >= 1 && tabSelected == 0"
					class="
						p-6
						border
						lg:rounded-l-lg
						md:rounded-tl-lg
						border-neutral-200
						md-down:rounded-t md-down:rounded-b-none
						w-full
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-6
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2"
							height="32"
							src="@/assets/images/icons/abc.png"
							style="height: 32px"
							width="32"
						/>
						{{ total_group_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng số nhóm
						</span>
					</div>
				</div>
				<div
					:class="
						total_group_count < 1
							? 'lg:rounded-l-lg md:rounded-tl-lg md-down:rounded-t md-down:rounded-b-none'
							: tabSelected == 0 && total_group_count < 1
							? 'md:border-l-0 md-down:border-t-0'
							: tabSelected == 1
							? 'md-down:rounded-t'
							: ''
					"
					class="p-6 border border-neutral-200 w-full"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-6
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2"
							height="32"
							src="@/assets/images/icons/abc.png"
							style="height: 32px"
							width="32"
						/>
						{{ skill_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng số lĩnh vực
						</span>
					</div>
				</div>
				<div
					:class="{
						'lg:rounded-r-lg': tabSelected == 0,
						'md:rounded-br-lg': tabSelected == 0,
					}"
					class="
						p-6
						border
						md:border-l-0
						border-neutral-200
						w-full
						md-down:border-t-0 md-down:rounded-t-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-6
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ goal_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng số mục tiêu</span
						>
					</div>
				</div>
				<div
					v-if="tabSelected == 1"
					class="
						p-6
						border
						md:border-l-0
						border-neutral-200
						w-full
						md-down:border-t-0 md-down:rounded-t-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-6
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ completed_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Mục tiêu hoàn thành</span
						>
					</div>
				</div>
				<div
					v-if="tabSelected == 1"
					class="
						p-6
						border
						md:border-l-0
						border-neutral-200
						w-full
						md-down:border-t-0 md-down:rounded-t-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-6
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ in_active_plan_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Mục tiêu trong KHHT</span
						>
					</div>
				</div>
				<div
					v-if="tabSelected == 1"
					class="
						p-6
						border
						md:border-l-0
						lg:rounded-r-lg
						border-neutral-200
						w-full
						md-down:border-t-0
						md-down:rounded-b
						md-down:rounded-t-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-6
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ in_pending_plan_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Mục tiêu trong KHDK</span
						>
					</div>
				</div>
			</div>
		</div>
		<div v-if="tabSelected === 0">
			<div v-if="groups && groups.length > 0">
				<div
					v-if="
						groups.length > 1 || groups?.[0]?.id !== 'no_have_group'
					"
				>
					<div
						v-for="(group, index) in groups"
						:key="group.id"
						class="mb-8"
					>
						<GroupDetailFull
							:data="group"
							:index="index"
							type="library"
							@refresh="listGroup"
							:student-id="Number(id)"
						/>
					</div>
				</div>
				<div v-else>
					<div
						v-for="(group, index) in groups?.[0]
							?.goals_group_by_skill"
						:key="group.id"
					>
						<GoalListFull
							:data="group"
							:index="index"
							:student-id="Number(id)"
							class="mb-6"
							type="library"
						/>
					</div>
				</div>
			</div>
			<div
				v-else
				class="w-full h-full flex items-center justify-center flex-col"
			>
				<img
					alt=""
					height="250"
					src="@/assets/images/illustrations/not_found.png"
					width="250"
				/>
				<div
					class="text-neutral-500 text-lg text-center"
					style="max-width: 700px"
				>
					Học sinh chưa có mục tiêu trong ngân hàng mục tiêu. Đây là
					nơi lưu trữ/ tập hợp các mục tiêu bạn dự định sẽ dạy trong
					tương lai (mục tiêu dài hạn, cơ bản, 3 - 6 tháng). Khi lên
					kế hoạch dự kiến, bạn có thể chọn mục tiêu từ Ngân hàng mục
					tiêu.
				</div>
				<div class="mt-8 flex items-center gap-4">
					<button
						v-if="!is_old_data"
						class="button-p btn--ghost w-fit"
						type="button"
						@click="router.push(`/recommend-goal/${id}`)"
					>
						<span class="whitespace-nowrap">Gợi ý mục tiêu</span>
					</button>
					<button
						v-if="!is_old_data"
						class="button-p btn--ghost w-fit"
						type="button"
						@click="redirectCreatePage"
					>
						<span class="whitespace-nowrap">Thêm mục tiêu</span>
					</button>
				</div>
			</div>
		</div>
		<div v-if="tabSelected === 1">
			<div v-if="groups.length > 0">
				<TwoLayerGoal
					:data="groups"
					:index="index"
					:student-id="Number(id)"
					@refresh="listTwoLayerGoal"
				/>
			</div>
			<div
				v-else
				class="w-full h-full flex items-center justify-center flex-col"
			>
				<img
					alt=""
					height="250"
					src="@/assets/images/illustrations/not_found.png"
					width="250"
				/>
				<div
					class="text-neutral-500 text-lg text-center"
					style="max-width: 700px"
				>
					Học sinh chưa có mục tiêu chung. Đây là nơi lưu trữ/ tập hợp
					các mục tiêu chung.
				</div>
				<div class="mt-8">
					<button
						v-if="!is_old_data"
						class="button-p btn--ghost w-fit"
						type="button"
						@click="router.push(`/create-goal?student_id=${id}`)"
					>
						<span class="whitespace-nowrap"
							>Thêm mục tiêu chung</span
						>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { _ROUTER_NAME } from '@/enums';
import router from '@/router';
import { useStore } from 'vuex';
import Loading from '@/components/common/Loading.vue';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { $api } from '@/services';
import GoalListFull from '@/components/elements/GoalListFull.vue';
import GroupDetailFull from '@/components/modules/groups/GroupDetailfull.vue';
import TwoLayerGoal from '@/components/elements/TwoLayerGoal.vue';
import { useTutorial } from '@/features/tutorial/useTutorial';
import { isTutorialVirtualStudent } from '@/features/tutorial/virtualStudent';

const route = useRoute();
const store = useStore();
const {
	activeSpotlight,
	advanceSpotlight,
	setSpotlightByTarget,
	isAddGoalTour,
} = useTutorial();
const groups = ref([]);
const skill_count = ref(0);
const goal_count = ref(0);
const completed_count = ref(0);
const in_active_plan_count = ref(0);
const in_pending_plan_count = ref(0);
const total_group_count = ref(0);
const isLoading = ref(false);
const tabs = ref([
	{
		name: 'Ngân hàng mục tiêu',
		value: 0,
	},
	{
		name: 'Quản lý mục tiêu chung',
		value: 1,
	},
]);
const tabSelected = ref(0);

const id = computed(() => (route.params?.id ? route.params?.id + '' : ''));

const is_old_data = ref(route.query.is_old_data === 'true');

onMounted(() => {
	if (route.query.tabSelected == 1) {
		tabSelected.value = 1;
	}
	if (tabSelected.value == 0) listGroup();
});

watch(tabSelected, () => {
	if (tabSelected.value == 0) listGroup();
	else listTwoLayerGoal();
});

async function listGroup() {
	try {
		isLoading.value = true;
		const {
			data: { data, stats },
		} = await $api.goal.getListGroupWithDetailInLibs(id.value);
		groups.value = data || [];
		if (stats) {
			skill_count.value = stats?.total_skill_count || 0;
			goal_count.value = stats?.total_goal_count || 0;
			total_group_count.value = stats?.total_group_count || 0;
		}
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	} finally {
		isLoading.value = false;
	}
}

async function listTwoLayerGoal() {
	try {
		isLoading.value = true;
		const {
			data: { data, stats },
		} = await $api.goal.getTwoLayerListGroupWithDetailInLibs(id.value);
		groups.value = data?.skills || [];
		if (stats) {
			skill_count.value = stats?.skills_count || 0;
			goal_count.value = stats?.goals_count || 0;
			completed_count.value = stats?.completed_count || 0;
			in_active_plan_count.value = stats?.in_active_plan_count || 0;
			in_pending_plan_count.value = stats?.in_pending_plan_count || 0;
		}
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	} finally {
		isLoading.value = false;
	}
}

function onBankMoreClick() {
	if (
		isAddGoalTour.value &&
		activeSpotlight.value?.targetId === 'bank-more-btn'
	) {
		advanceSpotlight();
	}
}

function redirectCreatePage() {
	if (isAddGoalTour.value || isTutorialVirtualStudent(id.value)) {
		router.push({
			name: _ROUTER_NAME.CREATE_GOAL_BY_LIB,
			params: {
				id: id.value,
			},
		});
		if (isAddGoalTour.value) {
			nextTick(() => setSpotlightByTarget('bank-lib-list'));
		}
		return;
	}
	router.push({
		name: _ROUTER_NAME.PLANS_REPORT_DETAIL__GOAL_CREATE_LIB__CREATE,
		params: {
			id: id.value,
		},
	});
}
</script>
<style scoped>
.tab {
	padding: 8px 12px 8px 12px;
	color: #48566a;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
}

.tab-selected {
	border-radius: 8px;
	background: #e5a42b;
	box-shadow: 0px 3px 8px -1px #3232470d;
	color: #fff;
}
</style>
